import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Home/Packages.css';
import { searchTrips } from '../functions/FetchTrips';
import UpcomingTrips from '../components/Home/UpcomingTrips';

const TripsPage = () => {
  const { category } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // Get data passed from Home component
  const { data, categoryTitle } = location.state || {};
  
  // Get search query from URL parameters
  const searchParams = new URLSearchParams(location.search);
  const searchQuery = searchParams.get('q');
  
  // Fetch search results when the search query changes
  useEffect(() => {
    const fetchSearchResults = async () => {
      if (searchQuery) {
        setLoading(true);
        setError(null);
        try {
          const results = await searchTrips(searchQuery);
          setSearchResults(results);
        } catch (error) {
          console.error("Error searching trips:", error);
          setSearchResults([]);
          setError('Failed to search trips. Please try again.');
        } finally {
          setLoading(false);
        }
      }
    };
    
    fetchSearchResults();
  }, [searchQuery]);
  
  // Function to navigate to itinerary page
  const goToItinerary = (packageId) => {
    navigate(`/itinerary/${packageId}`);
  };
  
  // Determine which data to display: search results or category data
  const displayData = searchQuery ? searchResults : data;
  const displayTitle = searchQuery ? `Search Results for "${searchQuery}"` : (categoryTitle || 'All Trips');

  return (
    <>
      <Header />
      <div className="container py-5" style={{ marginTop: '80px' }}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="travelscape-section-title mb-0">
            {displayTitle}
          </h2>
          <button 
            className="btn btn-outline-primary"
            onClick={() => navigate(-1)}
          >
            <i className="fas fa-arrow-left me-2"></i>
            Back
          </button>
        </div>
        {/* Use UpcomingTrips for displaying trips */}
        <UpcomingTrips 
          hideControls={true}
          trips={displayData}
          loading={loading}
          error={error}
        />
      </div>
      <Footer />
    </>
  );
};

export default TripsPage;
